var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"treeWrap",staticClass:"select-alert-class"},[_c('ul',_vm._l((_vm.basicData.data),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"main-class",attrs:{"title":item.name},on:{"click":function($event){return _vm.selectButClick(item)}}},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }